// Sobreposição de edição de um componente do PDV: nome, status, posição,
// tamanho e cores. Aparece por cima do modal quando um componente é escolhido.
import React from "react";
import * as AlfredoStyles from "../../../../styles/components/configuration/modals/ItemModal";
import { PDVComponent } from "./tipos";

export const EditorDoComponente: React.FC<{
  editingComponent: PDVComponent | null;
  setEditingComponent: (componente: PDVComponent | null) => void;
  updateComponentInSaleOption: (componentId: string, updates: any) => void;
  handleComponentPropChange: (
    componentId: string,
    propPath: string,
    value: any
  ) => void;
  removeComponentFromSaleOption: (componentId: string) => void;
}> = ({
  editingComponent,
  setEditingComponent,
  updateComponentInSaleOption,
  handleComponentPropChange,
  removeComponentFromSaleOption,
}) => {
  if (!editingComponent) return null;

  return (
    <AlfredoStyles.ComponentEditorOverlay>
      <AlfredoStyles.ComponentEditor>
        <AlfredoStyles.ComponentEditorHeader>
          <h3>
            <span className="material-icons">edit</span>
            Editor de Componente: {editingComponent.componentName}
          </h3>
          <button onClick={() => setEditingComponent(null)}>
            <span className="material-icons">close</span>
          </button>
        </AlfredoStyles.ComponentEditorHeader>

        <AlfredoStyles.ComponentEditorBody>
          <AlfredoStyles.FormSection>
            <AlfredoStyles.SectionTitle>
              Configurações Básicas
            </AlfredoStyles.SectionTitle>
            <AlfredoStyles.FormGrid>
              <AlfredoStyles.InputWrapper>
                <label>Nome do Componente</label>
                <AlfredoStyles.Input
                  type="text"
                  value={editingComponent.componentName}
                  onChange={(e) =>
                    updateComponentInSaleOption(
                      editingComponent.componentId,
                      { componentName: e.target.value }
                    )
                  }
                />
              </AlfredoStyles.InputWrapper>

              <AlfredoStyles.InputWrapper>
                <label>Status</label>
                <AlfredoStyles.Select
                  value={editingComponent.componentStatus}
                  onChange={(e) =>
                    updateComponentInSaleOption(
                      editingComponent.componentId,
                      { componentStatus: e.target.value }
                    )
                  }
                >
                  <option value="visible">Visível</option>
                  <option value="hidden">Oculto</option>
                </AlfredoStyles.Select>
              </AlfredoStyles.InputWrapper>
            </AlfredoStyles.FormGrid>
          </AlfredoStyles.FormSection>

          <AlfredoStyles.FormSection>
            <AlfredoStyles.SectionTitle>
              Posicionamento
            </AlfredoStyles.SectionTitle>
            <AlfredoStyles.FormGrid>
              <AlfredoStyles.InputWrapper>
                <label>Posição X (%)</label>
                <AlfredoStyles.Input
                  type="text"
                  value={
                    editingComponent.componentProps.componentPosition?.x ||
                    "0%"
                  }
                  onChange={(e) =>
                    handleComponentPropChange(
                      editingComponent.componentId,
                      "componentPosition.x",
                      e.target.value
                    )
                  }
                  placeholder="ex: 10%, 50px"
                />
              </AlfredoStyles.InputWrapper>

              <AlfredoStyles.InputWrapper>
                <label>Posição Y (%)</label>
                <AlfredoStyles.Input
                  type="text"
                  value={
                    editingComponent.componentProps.componentPosition?.y ||
                    "0%"
                  }
                  onChange={(e) =>
                    handleComponentPropChange(
                      editingComponent.componentId,
                      "componentPosition.y",
                      e.target.value
                    )
                  }
                  placeholder="ex: 20%, 100px"
                />
              </AlfredoStyles.InputWrapper>

              <AlfredoStyles.InputWrapper>
                <label>Largura</label>
                <AlfredoStyles.Input
                  type="text"
                  value={editingComponent.componentProps.componentWidth || ""}
                  onChange={(e) =>
                    handleComponentPropChange(
                      editingComponent.componentId,
                      "componentWidth",
                      e.target.value
                    )
                  }
                  placeholder="ex: 100px, 50%"
                />
              </AlfredoStyles.InputWrapper>

              <AlfredoStyles.InputWrapper>
                <label>Altura</label>
                <AlfredoStyles.Input
                  type="text"
                  value={
                    editingComponent.componentProps.componentHeight || ""
                  }
                  onChange={(e) =>
                    handleComponentPropChange(
                      editingComponent.componentId,
                      "componentHeight",
                      e.target.value
                    )
                  }
                  placeholder="ex: 100px, 50%"
                />
              </AlfredoStyles.InputWrapper>
            </AlfredoStyles.FormGrid>
          </AlfredoStyles.FormSection>

          <AlfredoStyles.FormSection>
            <AlfredoStyles.SectionTitle>
              Estilo Visual
            </AlfredoStyles.SectionTitle>
            <AlfredoStyles.FormGrid>
              <AlfredoStyles.InputWrapper>
                <label>Cor de Fundo</label>
                <AlfredoStyles.ColorInput
                  color={
                    editingComponent.componentProps
                      .componentBackgroundColor || "#1D50FF"
                  }
                >
                  <input
                    type="color"
                    value={
                      editingComponent.componentProps
                        .componentBackgroundColor || "#1D50FF"
                    }
                    onChange={(e) =>
                      handleComponentPropChange(
                        editingComponent.componentId,
                        "componentBackgroundColor",
                        e.target.value
                      )
                    }
                  />
                  <label>Fundo</label>
                </AlfredoStyles.ColorInput>
              </AlfredoStyles.InputWrapper>

              <AlfredoStyles.InputWrapper>
                <label>Cor do Texto</label>
                <AlfredoStyles.ColorInput
                  color={
                    editingComponent.componentProps.componentColor ||
                    "#FFFFFF"
                  }
                >
                  <input
                    type="color"
                    value={
                      editingComponent.componentProps.componentColor ||
                      "#FFFFFF"
                    }
                    onChange={(e) =>
                      handleComponentPropChange(
                        editingComponent.componentId,
                        "componentColor",
                        e.target.value
                      )
                    }
                  />
                  <label>Texto</label>
                </AlfredoStyles.ColorInput>
              </AlfredoStyles.InputWrapper>
            </AlfredoStyles.FormGrid>
          </AlfredoStyles.FormSection>
        </AlfredoStyles.ComponentEditorBody>

        <AlfredoStyles.ModalFooter>
          <AlfredoStyles.ButtonGroup>
            <AlfredoStyles.Button
              color="#f44336"
              onClick={() => {
                removeComponentFromSaleOption(editingComponent.componentId);
                setEditingComponent(null);
              }}
            >
              <span className="material-icons">delete</span>
              Excluir Componente
            </AlfredoStyles.Button>
            <AlfredoStyles.SecondaryButton
              onClick={() => setEditingComponent(null)}
            >
              Cancelar
            </AlfredoStyles.SecondaryButton>
            <AlfredoStyles.PrimaryButton
              onClick={() => setEditingComponent(null)}
            >
              <span className="material-icons">save</span>
              Salvar
            </AlfredoStyles.PrimaryButton>
          </AlfredoStyles.ButtonGroup>
        </AlfredoStyles.ModalFooter>
      </AlfredoStyles.ComponentEditor>
    </AlfredoStyles.ComponentEditorOverlay>
  );
};
